function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-803-2076h1920v6415H-803z"
}), React.createElement("path", {
  d: "M-803-1757h1920v6041H-803z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  d: "M93.156 65.804a1.282 1.282 0 0 1 1.862 1.76l2.159 2.162 2.952-2.81a5.37 5.37 0 0 1 3.724-1.474h12.515c4.239 0 7.688 3.31 7.688 7.38v28.973c0 4.07-3.449 7.38-7.688 7.38h-23.02c-4.239 0-7.687-3.31-7.687-7.38V82.824c0-1.356.573-2.68 1.574-3.633l2.23-2.123-.973-.973-.998-1a1.277 1.277 0 0 1-1.758-.049c-.5-.5-.501-1.311-.001-1.812zm23.212 2.201h-12.515c-.731 0-1.444.28-1.956.767L89.002 81.048a2.44 2.44 0 0 0-.778 1.776v18.97c0 2.657 2.299 4.818 5.124 4.818h23.02c2.826 0 5.124-2.161 5.124-4.817V72.822c0-2.656-2.298-4.817-5.124-4.817zm-1.442 4.033c2.272 0 4.12 1.849 4.12 4.122a4.125 4.125 0 0 1-4.12 4.122H95.654a1.282 1.282 0 0 1-.883-2.21l5.981-5.682c.239-.226.555-.352.883-.352zm0 2.563h-12.78l-3.282 3.118h16.062a1.56 1.56 0 0 0 0-3.118zM93.21 69.379l-3.901 3.905.802.804.994.995.218.217 3.999-3.807-.229-.228-.501-.502-.822-.823-.56-.561zm4.91 31.05c4.647 0 7.293-2.535 7.293-7.646 0-5.177-2.646-7.667-7.294-7.667-4.647 0-7.293 2.49-7.293 7.667 0 5.111 2.646 7.645 7.293 7.645zm0-2.272c-3.038 0-4.533-1.77-4.533-5.374 0-3.626 1.495-5.395 4.532-5.395s4.533 1.769 4.533 5.395c0 3.604-1.496 5.374-4.533 5.374zm19.832 2.14c.713 0 1.312-.568 1.312-1.245v-12.56c0-.677-.599-1.245-1.312-1.245-.713 0-1.311.568-1.311 1.245v8.65l-6.81-9.37c-.23-.329-.599-.525-1.059-.525-.713 0-1.311.568-1.311 1.245v12.56c0 .677.598 1.245 1.311 1.245s1.311-.568 1.311-1.245v-8.606l6.788 9.305c.23.328.644.546 1.081.546z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 84,
  y: 138.719
}, "Diesel")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/diesel.c9851770.svg";
export { SvgComponent as ReactComponent };